import Table from "@/components/AdvanceTable"
import ExprotExcel from "./exportexcel.vue"
import moment from "moment"
import {comdata} from './data'
import downloadexcel from "vue-json-excel";
import fn from './fn'
moment.locale("zh-cn")
let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)
export default {
	data(){
		return {...comdata}
	},
	components:{
		Table,
		ExprotExcel,
		downloadexcel
	},
	methods:{...fn},
	mounted(){
		this.getworkpalceArrary()
		this.getroomtypeArray()
	}
}


